<!-- 监测床位详情 -->
<template>
  <div class="realTimeMonitoringtwo">
		<div class="realTime_box">
			<div class="realTop_right" style="display: block;">
				<a-spin v-if="spinning" :spinning="spinning" tip="加载中" class="spin-item" :delay="100"></a-spin>
				<div class="toilet-status has-people" v-if="topStatus === 0">
					<img src="./../../assets/img/toilet_occupied@2x.png" alt="" />
					<span class="status-text">有人</span>
					<span class="status-text status-text-time">{{ toiletTimeStr }}</span>
				</div>
				<div class="toilet-status no-people" v-if="topStatus === 1">
					<img src="./../../assets/img/iconFalldownGrey@2x.png" alt="" />
					<span class="status-text">无人</span>
				</div>
				<div class="toilet-status off-line" v-if="topStatus === 2">
					<img src="./../../assets/img/iconFalldownGrey@2x.png" alt="" />
					<span class="status-text">离线</span>
				</div>
				<div class="toilet-status fall-people" v-if="topStatus === 3">
					<img src="./../../assets/img/toilet_alarm@2x.png" alt="" />
					<span class="status-text">已跌倒</span>
					<span class="status-text status-text-time">{{ toiletTimeStr }}</span>
				</div>
				<div class="toilet-status " v-if="topStatus === 4">
					<span class="status-text">监测仪已关闭</span>
				</div>
				<div class="toilet-status fall-people" v-if="topStatus === 6">
					<img src="./../../assets/img/iconToilet_redBG@2x.png" alt="" />
					<span class="status-text">已有人</span>
					<span class="status-text status-text-time">{{ toiletTimeStr }}</span>
				</div>
				<!-- <div class="pic-tit">
					<div>
						<a-popover
							v-model="showCalendar"
							overlayClassName="calendar-name"
							placement="bottom"
							@visibleChange="handleUpdateClick"
						>
							<template slot="content">
								<a-calendar
									:fullscreen="false"
									:defaultValue="$moment(activeDate, 'YYYY-MM-DD')"
									:value="$moment(activeDate, 'YYYY-MM-DD')"
									:validRange="[
										$moment(activeDates[activeDates.length - 1], 'YYYY-MM-DD'),
										$moment(activeDates[0], 'YYYY-MM-DD'),
									]"
									:disabledDate="getInvalidDates"
									@panelChange="panelChange"
									@select="changeDate"
								>
									<template slot="dateCellRender" slot-scope="value">
										<div v-show="getDayData(value)">
											<section>
												<div class="calDot"></div>
											</section>
										</div>
									</template>
								</a-calendar>
							</template>
							<div
								:class="{ actives: activeType == true }"
								class="hoverBtns on"
							>
								{{ activeDate.slice(5, 7) + '月' + activeDate.slice(8) + '日' }}
								<a-icon type="calendar" />
							</div>
						</a-popover>
					</div>
					<div class="left-right">
						<img src="./../../assets/img/iconLeftRight@2x.png" alt="" />
						<span>左右拖拽查看更多</span>
					</div>
				</div>
				<div class="pic">
					<pieCom
						ref="pieCom"
						:timeArr="timeArr"
						:bedId="bedId"
						@transfer="getActiveTime"
					></pieCom>
				</div> -->
			</div>
			<div class="realTop_right-line"></div>
			<div class="two_right">
				<div class="realTop_left">
					<div class="left_header">
						<span class="left_title">监测仪</span>
						<div style="position: relative;top: -2px;" v-if="role == 3">
							<el-switch
								v-model="switchStatus"
								:width="40"
								class="switch"
								active-color="#1890FF"
								inactive-color="#79b5f6"
								@change="setStatus"
							>
							</el-switch>
							<span v-if="switchStatus" style="top:5px" class="switch-btn-open"
								>开</span
							>
							<span v-else style="top:5px" class="switch-btn-off">关</span>
						</div>
						<div v-else style="position: relative;" class="title-flex">
							<el-switch
								v-model="switchStatus"
								:width="40"
								class="switch"
								active-color="#1890FF"
								inactive-color="#79b5f6"
								@change="setStatus"
							>
							</el-switch>
							<span v-if="switchStatus" class="switch-btn-open">开</span>
							<span v-else class="switch-btn-off">关</span>
							<div class="title-flex-set" @click="setToitet">设置</div>
						</div>
					</div>
				</div>
				<div class="right-bottom">
					<div class="situationRemarks">
						<div class="title">
							用户信息
							<a-button
								type="link"
								style="position: relative; float: right; left: 15px"
								@click="checkInfo()"
								v-if="bindUserInfoList && bindUserInfoList.length > 0"
								>完整查看</a-button
							>
						</div>
						<div
							class="people-msg"
							v-for="(item, ind) in bindUserInfoList"
							:key="ind"
						>
							<p>
								<span>{{ item.bindUserName }}</span>
								<span style="margin: 0px 15px;">{{ item.sexName }}</span>
								<span>{{ item.ageGroupName }}</span>
							</p>
							<p>{{ item.actionAbilityName }}</p>
						</div>
						<div class="no-data-people" v-if="bindUserInfoList.length == 0">
							提供用户基本信息，数据会更加精准
						</div>
					</div>
					<div class="right_box">
						<div class="box_header">
							<div @click="changeScroll" style="font-weight: normal;">
								历史信息
							</div>
							<div class="toViewMore" @click="handletoViewMore()">
								查看更多
							</div>
						</div>
						<div class="list">
							<div class="history-item" v-for="(item, index) in historyInfo" :key="index">
								<span class="history-time">{{ item.time }}</span>
								<span
									class="history-content"
									:style="{ color: hasSpanTag(item.content) ? '' : item.isAlarm === 1 ? 'rgba(255, 113, 134, 1)' : '' }"
									v-html="item.content"
								></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    
    <a-modal
      title="设置"
      :width="400"
      :visible="editAbnormalTimePopupToitet"
      :maskClosable="false"
      :footer="null"
      @cancel="editAbnormalTimeCancelToitet"
    >
      <div class="picker">
        <div class="titleTime">卫生间停留异常时长</div>
        <el-time-picker
          v-model="editHandleTimeValToitet2"
          format="HH:mm:ss"
          value-format="HH:mm"
        >
        </el-time-picker>
      </div>
      <div class="toitet-pop-tips">
        <div>*仅能设置“时”和“分”</div>
        <div :class="isLessTime ? 'isLessTime' : ''">*最短只能设置到10分钟</div>
      </div>
      <div class="addBtn toitet-btn">
        <a-button
          style="margin-right: 10px"
          @click="editAbnormalTimeCancelToitet"
          >取消</a-button
        >
        <a-button type="primary" @click="editAbnormalTimeToitet">确定</a-button>
      </div>
    </a-modal>
    <!-- 完整查看弹窗 -->
    <!-- 录入查看床位 -->
    <a-modal
      v-model="formVisible"
      footer=""
      :width="1000"
      :title="formTitle"
      v-if="inputForm"
      class="lrck_TanWrap"
    >
      <div class="tanUserInfoWrap modal—top">
        <div class="tanUlist">
          <div class="box">
            <div class="name">设备码</div>
            <div class="name2">{{ fallDeviceInfoList[0].sn }}</div>
          </div>
          <div class="box">
            <div class="name">监测床位</div>
            <div class="name2" style="width:280px;">
              {{ fallDeviceInfoList[0].bedName }}
            </div>
          </div>
          <div class="box" v-if="fallDeviceInfoList[0].bindMobilePhone">
            <div class="name">绑定手机号</div>
            <div class="name2">{{ fallDeviceInfoList[0].bindMobilePhone }}</div>
          </div>
        </div>
      </div>
      <div v-for="(wcItem, wcIndex) in inputForm" :key="wcIndex">
        <div :class="wcIndex != 0 ? 'lrck_tableWrap' : ''">
          <div class="tanUserInfoWrap">
            <div class="tanUlist">
              <div class="box">
                <div class="name">关联设备码</div>
                <div class="name2">{{ wcItem.snCode }}</div>
              </div>
              <div class="box">
                <div class="name">关联位置</div>
                <div class="name2">{{ wcItem.bedName }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">姓名</div>
                <div class="name2">{{ wcItem.name }}</div>
              </div>
              <div class="box">
                <div class="name">性别</div>
                <div class="name2">{{ wcItem.sex == 1 ? '男' : '女' }}</div>
              </div>
              <div class="box">
                <div class="name">年龄段</div>
                <div class="name2">{{ wcItem.ageGroupName }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">出生日期</div>
                <div class="name2">{{ wcItem.birthday }}</div>
              </div>
              <div class="box">
                <div class="name">身份证号</div>
                <div class="name2">{{ wcItem.idCard }}</div>
              </div>
              <div class="box">
                <div class="name">紧急联系人</div>
                <div
                  class="name2 overhidFont"
                  :title="wcItem.mobilePhone"
                  style="width:130px;"
                >
                  {{ wcItem.mobilePhone || '' }}
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">护理等级</div>
                <div class="name2">{{ wcItem.nursingLevelName }}</div>
              </div>
              <div class="box">
                <div class="name">行动能力</div>
                <div class="name2">{{ wcItem.actionAbilityName }}</div>
              </div>
              <div class="box" v-if="wcItem.livingStateName">
                <div class="name">行为状态</div>
                <div class="name2">{{ wcItem.livingStateName || '' }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">呼吸</div>
                <div class="name2">
                  <span :key="index" v-for="(item, index) in wcItem.breathList">
                    <span v-if="wcItem.breathList.length == 1">{{ item }}</span>
                    <span
                      v-if="
                        wcItem.breathList.length > 1 &&
                          index != wcItem.breathList.length - 1
                      "
                      >{{ item }}、</span
                    >
                    <span
                      v-if="
                        wcItem.breathList.length > 1 &&
                          index == wcItem.breathList.length - 1
                      "
                      >{{ item }}</span
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">心脏</div>
                <div class="name2">
                  <span :key="index" v-for="(item, index) in wcItem.heartList">
                    <span v-if="wcItem.heartList.length == 1">{{ item }}</span>
                    <span
                      v-if="
                        wcItem.heartList.length > 1 &&
                          index != wcItem.heartList.length - 1
                      "
                      >{{ item }}、</span
                    >
                    <span
                      v-if="
                        wcItem.heartList.length > 1 &&
                          index == wcItem.heartList.length - 1
                      "
                      >{{ item }}</span
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">睡眠状况</div>
              </div>
              <div
                style="background:#f0f0f0;width:calc(100% - 82px);height:100%;"
              ></div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">是否失眠</div>
                <div class="name2">{{ wcItem.insomniaName }}</div>
              </div>
              <div class="box">
                <div class="name">是否打呼噜</div>
                <div class="name2">{{ wcItem.insomniaName }}</div>
              </div>
              <div class="box">
                <div class="name">起夜频次</div>
                <div class="name2">{{ wcItem.nightFrequencyName }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name" style="width:166px;">
                  已知睡眠呼吸障碍疾病
                </div>
                <div class="name2">
                  <span
                    :key="index"
                    v-for="(item, index) in wcItem.sleepDisorderedBreathingList"
                  >
                    <span
                      v-if="wcItem.sleepDisorderedBreathingList.length == 1"
                      >{{ item }}</span
                    >
                    <span
                      v-if="
                        wcItem.sleepDisorderedBreathingList.length > 1 &&
                          index !=
                            wcItem.sleepDisorderedBreathingList.length - 1
                      "
                      >{{ item }}、</span
                    >
                    <span
                      v-if="
                        wcItem.sleepDisorderedBreathingList.length > 1 &&
                          index ==
                            wcItem.sleepDisorderedBreathingList.length - 1
                      "
                      >{{ item }}</span
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">跌倒史</div>
                <div class="name2">{{ wcItem.fallHistoryName }}</div>
              </div>
              <div class="box">
                <div class="name" style="width:138px;">有超过1个医学诊断</div>
                <div class="name2">{{ wcItem.medicalDiagnosisName }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name" style="width:208px;">
                  静脉输液/置管/使用特殊药物
                </div>
                <div class="name2">{{ wcItem.infusionName }}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">步态</div>
                <div class="name2">{{ wcItem.gaitName }}</div>
              </div>
              <div class="box">
                <div class="name">认知状态</div>
                <div class="name2" style="width:340px;">
                  {{ wcItem.cognitiveStateName }}
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">备注</div>
                <div
                  class="name2"
                  style="width:860px;overflow-x: auto;white-space: nowrap;"
                >
                  {{ wcItem.remarks }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear mt20">
        <div style="float: right">
          <el-button @click="formVisible = false">关闭</el-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import pieCom from './pieCom.vue';
import Global from '../../utils/global';
import { createGlobalStompScope } from '@/utils/stomp';
export default {
  name: 'ToiletCom',
  props: {
    bedId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      role: 2,
      isTextarea: false, // 是否显示文本框
      textarea: '', // 文本框内容
      isSubmit: false, // 是否提交文本框内容
      dates: [],
      minutes: [],
      effeDatesData: null,
      effeDates: [],
      invalidDates: [],
      activeType: 1, // 默认今天
      activeDates: [],
      activeDate: '',
      showCalendar: false,
      switchStatus: true,
      historyInfo: [],
      bindUserInfoList: [],
      topStatus: '',
      timeArr: [],
      allTime: [],
      beginTime: '',
      endTime: '',
      columnFlag: 0,
      calendarActiveDate: '',
      inputForm: [],
      fallDeviceInfoList: [
        {
          sn: '',
          bedName: '',
        },
      ],
      formVisible: false,
      formTitle: '',
      stompClient: null,
      stompClientStatus: null,
      toiletTimeStr: '00:00:00',
      computToiletInteiv: null,
      toitetTypeData: 2, // 卫生间停留过久类型
      toitetId: '', // 卫生间停留过久设备id
      isLessTime: false, // 卫生间停留过久是否小于10分钟
      editHandleTimeValToitet: '', // 卫生间异常时间值
      editHandleTimeValToitet2: '', // 卫生间异常时间值
      editAbnormalTimePopupToitet: false,
			spinning: false,
    };
  },
  components: {
    pieCom,
  },
  created() {
    // console.log(this.routerId)
    //this.getTheChart();
    console.log(this.bedId);
    this.timeArr.forEach((item) => {
      if (item.time.slice(-2) === '00') {
        item.isShowTime = true;
      }
    });
    this.getDetailData();
    this.role = this.$getCookie('userInfo').user.roleId;
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    let a = document.getElementsByClassName('box');
    if(a&&a.length) {
    	console.log(a[0].scrollWidth);
			a[0].scrollLeft = a[0].scrollWidth - 800;
		}
    this.getHealthPageV1All();
    this.getMinutes();
    this.getDates();
    this.getActiveDates();
    this.activeDate = this.activeDates[0];
    console.log(this.activeDate, this.activeDates);
    this.getSocketStatus();
    this.getSocketEvent();
  },
  methods: {
    moment,
    // 设置卫生间停留时长
    setToitet() {
      console.log();
      this.editAbnormalTimePopupToitet = true;
      let param = {
        bedId: this.toitetId,
      };

      this.$get(
        '/api/app/v1/getFallLongTime',
        param,
        (res) => {
          if (res.code == 0) {
            console.log(123, res);
            this.editHandleTimeValToitet2 = res.data.outBedTime;
          }
        },
        (err) => {}
      );
    },
		hasSpanTag(content) {
			if (!content) {
				return false;
			}
			return content.indexOf('<span') !== -1;
		},
    // 卫生间停留时长取消
    editAbnormalTimeCancelToitet() {
      this.editAbnormalTimePopupToitet = false;
    },
    // 卫生间停留时长确定
    editAbnormalTimeToitet() {
      let time =
        Number(this.editHandleTimeValToitet2.split(':')[0] * 3600) +
        Number(this.editHandleTimeValToitet2.split(':')[1] * 60);
      console.log(time);
      if (time < 600) {
        this.isLessTime = true;
        return false;
      }
      this.isLessTime = false;
      console.log(this.editHandleTimeValToitet2.length)
      let editHandleTimeValToitet2;
      if(this.editHandleTimeValToitet2.length == 5){
        editHandleTimeValToitet2 = this.editHandleTimeValToitet2 + ':00';
      }else{
        editHandleTimeValToitet2 = this.editHandleTimeValToitet2;
      }
      let param = {
        bedId: this.toitetId,
        outBedTime: editHandleTimeValToitet2
      };
      this.$post(
        '/api/app/v1/setFallLongTime',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');

            this.editAbnormalTimePopupToitet = false;
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    changeShowCalendar() {
      this.showCalendar = true;
    },
    getActiveTime(message) {
      console.log(message);
      this.activeDate = message;
    },
    // 点击提交按钮关闭监测仪备注
    handleSumbit() {
      if (!this.textarea) {
        this.$message.error('请输入备注');
        return;
      }
      this.isTextarea = this.switchStatus ? false : true;
      let param = {
        bedId: +this.$route.query.id || this.bedId,
        remarks: this.textarea,
      };
      this.$post(
        '/api/monitor/closeRemark',
        param,
        (res) => {
          if (res.code == 0) {
            console.log(123);
            this.isSubmit = !this.isSubmit;
          }
        },
        (err) => {}
      );
    },
    changeScroll() {
      let dateFlag = 0;
      let scroll = document.getElementsByClassName('box');
      console.log(scroll[0].scrollLeft);
      let flag = Math.round(scroll[0].scrollLeft / 10);
      let newDate = this.timeArr[flag].date;
      let forLength = flag + 72;
      for (let i = flag; i < forLength; i++) {
        if (this.timeArr[i].date === newDate) {
          dateFlag++;
          if (dateFlag > 36) {
            this.activeDate = this.timeArr[i].date;
          }
        }
      }
      console.log(this.calendarActiveDate);
    },
    getHealthPageV1All() {
      let param2 = {
        bedId: this.$route.query.id || this.bedId, // 当前页
      };
      this.$get(
        '/api/bed/getFallCalendarById',
        param2,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.effeDatesData = res.data.data;
              // console.log(this.effeDatesData);
              this.effeDates = [];
              var vdates = [];
              for (var i = 0; i < this.effeDatesData.length; i++) {
                for (var key in this.effeDatesData[i]) {
                  if (key != 'reason') {
                    vdates.push(key);
                  }
                }
                if (this.effeDatesData[i].reason === '数据解析成功') {
                  for (var key in this.effeDatesData[i]) {
                    if (key != 'reason') {
                      this.effeDates.push(key);
                    }
                  }
                }
              }
              console.log(22223333, this.activeDates, vdates);
              this.invalidDates = [];
              for (var i = 0; i < this.activeDates.length; i++) {
                if (!vdates.includes(this.activeDates[i])) {
                  this.invalidDates.push(this.activeDates[i]);
                }
              }
              // console.log("##", this.invalidDates);
              // console.log(this.effeDates);
            } else {
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          //console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    btnClick(val, valDate, num) {
      console.log(val, valDate, num);
      this.activeType = val;
      this.activeDate = valDate;
      if (val == 3 || val == 4) this.date = ['选择日期'];
      if (this.detailsPopup) {
        this.clearCharts();
        if (val == 1 || val == 2) {
          this.getDetailsDataSingle();
        } else {
          this.getDetailsData();
        }
      }
      let timeData = valDate + ' 00:00:00';
      let timeStamp = new Date(timeData);
      timeStamp = new Date(timeStamp - 1000 * 3600 * 2);
      let htm =
        timeStamp.getFullYear() +
        '-' +
        ('00' + (1 + timeStamp.getMonth())).slice(-2) +
        '-' +
        ('00' + timeStamp.getDate()).slice(-2) +
        ' ' +
        ('00' + timeStamp.getHours()).slice(-2) +
        ':' +
        ('00' + timeStamp.getMinutes()).slice(-2) +
        ':' +
        ('00' + timeStamp.getSeconds()).slice(-2);
      this.timesDiff(htm);
    },
    timesDiff(timesData) {
      let targetTime = new Date().getTime();
      let startTime = new Date(timesData).getTime();
      let targetHours = Math.ceil((targetTime - startTime) / 1000 / 60 / 60);
      console.log(targetHours);
      this.$refs.pieCom.getDetailDataToPart(timesData, 2, targetHours, 'clear');
    },
    panelChange(date) {
      var dd = date._d;
      var y = dd.getFullYear().toString();
      var m = (dd.getMonth() + 1).toString();
      if (m.length <= 1) m = '0' + m;
      var d = dd.getDate().toString();
      if (d.length <= 1) d = '0' + d;
      var ad = y + '-' + m + '-' + d;
      //console.log(ad);
      if (this.activeDates.indexOf(ad) == -1) {
        var adn = ad;
        adn = parseInt(adn.split('-').join(''));
        var adsn = this.activeDate;
        adsn = parseInt(adsn.split('-').join(''));
        if (adn > adsn) {
          this.btnClick(1, this.activeDates[0], 2);
        } else {
          this.btnClick(1, this.activeDates[this.activeDates.length - 1], 2);
        }
      } else {
        this.btnClick(1, ad, 2);
      }
    },
    changeDate(date) {
      var dd = date._d;
      var y = dd.getFullYear().toString();
      var m = (dd.getMonth() + 1).toString();
      if (m.length <= 1) m = '0' + m;
      var d = dd.getDate().toString();
      if (d.length <= 1) d = '0' + d;
      var ad = y + '-' + m + '-' + d;
      //console.log(ad);
      this.btnClick(1, ad, 2);
    },
    getDayData(value) {
      for (var i = 0; i < this.effeDates.length; i++) {
        var m = parseInt(this.effeDates[i].slice(5, 7)) - 1;
        var d = parseInt(this.effeDates[i].slice(8, 10));
        if (value.month() == m && value.date() == d) {
          console.log(
            value.month(),
            value.date(),
            this.effeDates,
            'hahahahahahahhahah'
          );
          return true;
        }
      }
    },
    getInvalidDates: function(value) {
      for (var i = 0; i < this.invalidDates.length; i++) {
        var m = parseInt(this.invalidDates[i].slice(5, 7)) - 1;
        var d = parseInt(this.invalidDates[i].slice(8, 10));
        if (value.month() == m && value.date() == d) return true;
      }
    },
    handleUpdateClick() {
      console.log(123444);
      // this.showCalendar = false;
      // this.showCalendar = true;
    },
    getMinutes() {
      var day = new Date();
      for (var i = 0; i < 751; i++) {
        var ms = 12 * 3600 * 1000 + 60000 * i;
        day.setTime(parseInt(ms));
        var h = day.getHours().toString();
        if (h.length <= 1) h = '0' + h;
        var m = day.getMinutes().toString();
        if (m.length <= 1) m = '0' + m;
        this.minutes[i] = h + ':' + m;
      }
      // console.log(this.minutes);
    },
    getDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 6; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var m = (day.getMonth() + 1).toString();
        //if(m.length <= 1) m = "0" + m;
        var d = day.getDate().toString();
        this.dates[i] = m + '月' + d + '日';
      }
    },
    getActiveDates() {
      var day = new Date();
      var time = day.getTime();
      for (var i = 0; i <= 29; i++) {
        var ms = 24 * 3600 * 1000 * i;
        day.setTime(parseInt(time - ms));
        var y = day.getFullYear().toString();
        var m = (day.getMonth() + 1).toString();
        if (m.length <= 1) m = '0' + m;
        var d = day.getDate().toString();
        if (d.length <= 1) d = '0' + d;
        this.activeDates[i] = y + '-' + m + '-' + d;
      }
      //console.log(this.activeDates);
    },
    getSocketStatus() {
      console.log('huahasdhakjshdjakshd');
      let id = this.$route.query.id || this.bedId;
      if (this.stompClientStatus) {
        this.stompClientStatus.destroy();
        this.stompClientStatus = null;
      }
      this.stompClientStatus = createGlobalStompScope({
        vm: this,
        name: 'toilet-room-status',
      });
      console.log('ididididididid', id);
      this.stompClientStatus.subscribe('/topic/bedStatus.' + id, ({ body: socketData }) => {
              if (socketData.status === 1 && socketData.subStatus === 6) {
                this.topStatus = 0; // 有人
                clearInterval(this.computToiletInteiv);
                this.computToilet(socketData.duration);
              } else if (
                socketData.status === 1 &&
                socketData.subStatus === 5
              ) {
                this.topStatus = 1; // 无人
                this.toiletTimeStr = '';
                clearInterval(this.computToiletInteiv);
              } else if (socketData.status === 3) {
                this.topStatus = 2; // 离线
                this.toiletTimeStr = '';
                clearInterval(this.computToiletInteiv);
              } else if (
                (socketData.status === 5 || socketData.status === 6) &&
                socketData.subStatus === 2
              ) {
                this.topStatus = 3; // 报警
                clearInterval(this.computToiletInteiv);
                this.computToilet();
              } else if (socketData.status === 4) {
                this.topStatus = 4; // 关闭监测仪
                this.toiletTimeStr = '';
                clearInterval(this.computToiletInteiv);
              } else if (
                (socketData.status === 5 || socketData.status === 6) &&
                socketData.subStatus === 9
              ) {
                clearInterval(this.computToiletInteiv);
                this.topStatus = 6; // 长时间停留
                this.computToilet(socketData.duration);
              }
              // this.modificationSubscription(JSON.parse(greeting.body));
      });
      this.stompClientStatus.connect();
    },
    getSocketEvent() {
      let id = this.$route.query.id || this.bedId;
      if (this.stompClient) {
        this.stompClient.destroy();
        this.stompClient = null;
      }
      this.stompClient = createGlobalStompScope({
        vm: this,
        name: 'toilet-room-event',
      });
      this.stompClient.subscribe('/topic/bedEvent.' + id, ({ body: socketData }) => {
        console.log(socketData, '999999999999');
        this.historyInfo.unshift(socketData);
        this.historyInfo.pop();
      });
      this.stompClient.connect();
    },

    getCookie(c_name) {
      var name = c_name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i].trim()); // 解码
        if (c.indexOf(name) == 0) {
          return JSON.parse(c.substring(name.length, c.length));
        }
      }
      return '';
    },
    computToilet(data = 0) {
      clearInterval(this.computToiletInteiv);
      this.computToiletInteiv = null;
      console.log(123);
      let time = data;
      this.computToiletInteiv = setInterval((item) => {
        time++;
        console.log(123);
        this.toiletTimeStr = this.formatSeconds(time);
      }, 1000);
    },
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result =
        '' +
        (parseInt(secondTime) < 10
          ? '0' + parseInt(secondTime)
          : parseInt(secondTime));

      // if (minuteTime > 0) {
      result =
        '' +
        (parseInt(minuteTime) < 10
          ? '0' + parseInt(minuteTime)
          : parseInt(minuteTime)) +
        ':' +
        result;
      // }
      // if (hourTime > 0) {
      result =
        '' +
        (parseInt(hourTime) < 10
          ? '0' + parseInt(hourTime)
          : parseInt(hourTime)) +
        ':' +
        result;
      // }
      return result;
    },
    handletoViewMore() {
      Global.$emit('handleName', {
        e: this.$parent.$parent.navText2,
        type: 0,
      });
      let path = '';
      if (this.$getCookie('userInfo').user.roleId == 2) {
        path = '/dean/moreBed';
      } else if (this.$getCookie('userInfo').user.roleId == 3) {
        path = '/protect/moreBed';
      }
      this.$router.push({
        path: path,
        query: {
          bedId: this.$route.query.id || this.bedId,
          is: 1,
        },
      });
    },
    checkInfo() {
      let parasm = {
        bedId: this.$route.query.id || this.bedId,
      };
      this.$get(
        '/api/bed/getFallUserInfoById',
        parasm,
        (res) => {
          if (res.code == 0) {
            this.inputForm = res.data.fallBindBedInformationList;
            this.fallDeviceInfoList = res.data.fallDeviceInfoList;
            this.formVisible = true;
            this.formTitle = '查看卫生间信息';
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getDetailData() {
      //  this.$route.query.id || this.bedId  262
      let params = {
        bedId: this.$route.query.id || this.bedId,
      };
      this.spinning = true;
      this.$get(
        '/api/bed/getFallDeviceById',
        params,
        (res) => {
          console.log(110, res);
          if (res.code == 0) {
            this.switchStatus = res.data.onOff === 1 ? true : false;
            this.isTextarea = res.data.onOff === 0 ? true : false;
            this.historyInfo = res.data.historyInfo;
            this.bindUserInfoList = res.data.bindUserInfoList;
            this.toitetId = res.data.id;
            if (res.data.remarks) {
              this.isSubmit = false;
            } else {
              this.isSubmit = true;
            }
            this.textarea = res.data.remarks;
            if (res.data.status === 1 && res.data.subStatus === 6) {
              this.topStatus = 0; // 有人
              // this.toiletTimeStr = '';
              clearInterval(this.computToiletInteiv);
              this.computToilet(res.data.duration);
            } else if (res.data.status === 1 && res.data.subStatus === 5) {
              this.topStatus = 1; // 无人
              this.toiletTimeStr = '';
              clearInterval(this.computToiletInteiv);
            } else if (res.data.status === 3) {
              this.topStatus = 2; // 离线
              this.toiletTimeStr = '';
              clearInterval(this.computToiletInteiv);
            } else if (
              (res.data.status === 5 || res.data.status === 6) &&
              res.data.subStatus == 2
            ) {
              clearInterval(this.computToiletInteiv);
              this.computToilet(+res.data.duration);

              this.topStatus = 3; // 报警
            } else if (res.data.status === 4) {
              this.topStatus = 4; // 关闭监测仪
              this.toiletTimeStr = '';
              clearInterval(this.computToiletInteiv);
            } else if (
              (res.data.status === 5 || res.data.status === 6) &&
              res.data.subStatus === 9
            ) {
              clearInterval(this.computToiletInteiv);
              this.toiletTimeStr = '';
              this.topStatus = 6; // 长时间停留
              this.computToilet(res.data.duration);
            }
          }
					this.spinning = false;
        },
        (err) => {
          this.spinning = false;
          console.log(err);
        }
      );
    },
    setStatus() {
      this.isTextarea = this.switchStatus ? false : true;
      let param = {
        bedId: this.$route.query.id || this.bedId,
        onOff: this.switchStatus ? 1 : 0,
      };
      this.$put(
        '/api/monitor/onOff',
        param,
        (res) => {
          if (res.code == 0) {
            // console.log(123);
            if (this.switchStatus == 1) {
              this.$message.success('监测仪已开启');
            } else {
              this.$message.success('监测仪已关闭');
            }
          }
        },
        (err) => {}
      );
    },
  },
  destroyed() {},
  beforeDestroy() {
  if (this.stompClient) {
    this.stompClient.destroy();
    this.stompClient = null;
  }
  if (this.stompClientStatus) {
    this.stompClientStatus.destroy();
    this.stompClientStatus = null;
  }
    clearInterval(this.setInterval);
    clearInterval(this.leaveBedSetTimeVal);
    // clearInterval(this.setInterval2);
    //clearInterval(this.setInterva3);
  },
};
</script>
<style scoped lang="scss">
.picker {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  .titleTime {
    margin-right: 10px;
	white-space: nowrap;
  }
}
.toitet-pop-tips {
  margin-top: -20px;
  margin-left: 136px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bfbfbf;
  .isLessTime {
    color: #ff4d4f;
  }
}
.toitet-btn {
  margin-top: 20px;
  margin-left: 210px;
}
.ant-modal-body {
}
::v-deep .ant-modal-body {
  background: #fff;
}
.modal—top {
  margin-bottom: 30px;
}
.situationRemarks {
  width: 310px;
  position: relative;
  box-sizing: border-box;
  margin-top: 10px;
  background: #ffffff;
  .title {
    font-size: 18px;
    color: rgba(38, 38, 38, 0.7);
    border-radius: 0px 8px 0 0;
  }
  .people-msg {
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 20px;
    margin-top: 10px;
  }
  .no-data-people {
    display: flex;
    align-items: center;
    margin: 10px;
    margin-left: 0;
  }
  .people-msg:last-of-type {
    border: none;
  }
}
/* @import url(); 引入css类 */
.font {
  font-size: 18px;
  font-family: PingFangSC-regular, PingFang SC;
  font-weight: 500;
  color: #262626;
}
.realTimeMonitoringtwo {
  min-height: calc(100vh - 340px);
  height: 100%;
  .realTime_header {
    width: 100%;
    height: 56px;
    width: 1440px;
    box-sizing: border-box;
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
    padding: 0 130px 0 140px;
  }
  .realTime_box {
    display: flex;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 0 0 8px 8px;
    overflow: hidden;
    padding: 15px 0;
    background: #ffffff;
  }
  .realTop_right {
    width: 880px;
    min-height: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    background: #ffffff;
    position: relative;

    .toilet-status {
      height: 100%;
      background: #f5f5f5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 54px;
        height: 54px;
      }
      span {
        margin-left: 20px;
        font-size: 14px;
        color: #8c8c8c;
      }
      .status-text {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #8c8c8c;
      }
      .status-text-time {
        margin-left: 20px;
      }
    }
    .off-line {
      span {
        color: #ff4d4f;
      }
    }
    .has-people {
      span {
        color: #262626;
      }
    }
    .no-people {
      span {
        color: #262626;
      }
    }
    .fall-people {
      background: #ffccc7;
      span {
        font-size: 36px;
        color: #ff4d4f !important;
      }
    }
    .pic-tit {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;

      .hoverBtns:hover {
        background: #ffffff !important;
        color: #1890ff !important;
        border: 1px solid #1890ff !important;
      }
      .actives {
        background: #e6f7ff !important;
        color: #1890ff !important;
        border: 1px solid #1890ff !important;
      }
      .on {
        transition: color 0.3s, background 0.3s, border-color 0.3s;
        border-radius: 2px;
        padding: 6px 12px;
        cursor: pointer;
        margin-right: 10px;
        color: #262626;
        background: #ffffff;
        border: 1px solid #d9d9d9;
      }
    }
    .pic {
      margin-top: 20px;
      width: 900px;
      height: 220px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;

      .content {
        width: 900px;
        height: 190px;
        display: flex;
        position: relative;
        left: -5px;
        .timeX {
          text-align: right;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          justify-content: space-between;
          p {
            width: 50px;
          }
        }
        .box {
          position: relative;
          width: 800px;
          overflow: auto;
        }
        .box-column {
          height: 180px;
          position: relative;
          .column-con {
            height: 150px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .column {
            flex-shrink: 0;
            width: 10px;
            background: #f5f5f5;
            height: 150px;
            margin-left: 1px;
            float: left;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            overflow: hidden;
            .item {
              height: 15px;
            }
            .has-people-item {
              background: #52c41a;
            }
          }
        }
        .time-column {
          font-size: 12px;
          display: flex;
          align-items: center;
          margin-left: -15px;
          justify-content: space-between;
          .times {
            margin-left: -10px;
          }
        }
        .time-column-point {
          font-size: 12px;
          display: flex;
          position: relative;

          div {
            display: inline-block;
          }
          div:first-of-type {
            .Xtime {
              margin-left: 0;
              opacity: 0;
            }
          }
          .time-start {
            font-size: 12px;
            position: absolute;
            bottom: -10px;
            left: 0;
          }
          .time-end {
            font-size: 12px;
            position: absolute;
            bottom: -10px;
            right: -75px;
          }
          .time-start::before {
            position: absolute;
            top: -10px;
            left: 0;
            content: '';
            height: 10px;
            width: 1px;
            background: #262626;
          }
          .time-start::after {
            position: absolute;
            top: -10px;
            left: 33px;
            content: '';
            height: 10px;
            width: 1px;
            background: #262626;
          }
          .time-end::after {
            position: absolute;
            top: -10px;
            left: 17px;
            content: '';
            height: 10px;
            width: 1px;
            background: #262626;
          }
          .Xtime {
            position: relative;
            top: 10px;
            left: -15px;
            display: inline-block;
            width: 30px;
            margin-left: 36px;
          }

          .Xtime::before {
            position: absolute;
            top: -10px;
            left: 15px;
            content: '';
            height: 10px;
            width: 1px;
            background: #262626;
          }
          .Xtime::after {
            position: absolute;
            top: -10px;
            left: 50px;
            content: '';
            height: 10px;
            width: 1px;
            background: #262626;
          }
        }
      }
    }
    .left-right {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 30px;
      }
    }
  }
  .realTop_right-line {
    width: 1px;
    background-image: linear-gradient(
      to bottom,
      #bfbfbf 50%,
      #bfbfbf 50%,
      transparent 0%
    );
    background-size: 1px 10px;
    background-repeat: repeat-y;
    // margin-bottom: 15px;
  }
  .realTop_left {
    width: 330px;
    box-sizing: border-box;
    background: #ffffff;
    .left_header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .left_title {
        font-size: 18px;
        font-weight: 400;
        color: #262626;
        margin-right: 15px;
        margin-left: 10px;
      }
      .switch-btn-open {
        font-size: 12px;
        color: #ffffff;
        position: absolute;
        top: 3px;
        left: 5px;
      }
      .switch-btn-off {
        font-size: 12px;
        color: #ffffff;
        position: absolute;
        top: 3px;
        left: 22px;
      }
      .title-flex {
        flex: 1;
        display: flex;
        justify-content: space-between;
        .title-flex-set {
          color: #1890ff;
          cursor: pointer;
        }
      }
    }

    .textarea_div {
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .show_textarea {
        width: 290px;
        min-height: 67px;
        background: #e6f7ff;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #262626;
        padding: 5px 12px;
        overflow-wrap: break-word;
      }
      textarea {
        width: 290px;
        resize: none;
      }
      .btn {
        width: 48px;
        height: 24px;
        margin-top: 10px;
        background: #1890ff;
        border-radius: 12px;
        font-size: 12px;
        padding: 0;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: -2px;
      }
    }
  }

  .two_right {
    width: 350px;
    background: #ffffff;
    flex: 1;
    .right_box {
      width: 310px;
      position: relative;
      box-sizing: border-box;
      margin-top: 9px;
      background-image: linear-gradient(
        to right,
        #bfbfbf 0%,
        #bfbfbf 50%,
        transparent 50%
      );
      background-size: 10px 1px;
      background-repeat: repeat-x;
      .box_header {
        display: flex;
        padding-top: 10px;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        color: rgba(38, 38, 38, 0.7);
        margin-bottom: 10px;
        @extend .font;
        .toViewMore {
          font-size: 14px;
          font-weight: 400;
          color: #1890ff;
          cursor: pointer;
          @extend .font;
        }
      }
      .list {
        margin-top: 10px;
        .history-item {
          font-size: 14px;
          line-height: 20px;
          color: rgba(94, 103, 121, 1);
        }
        .history-item + .history-item {
          margin-top: 6px;
        }
        .history-time {
          display: inline;
          white-space: nowrap;
        }
        .history-content {
          display: inline;
          margin-left: 8px;
          word-break: break-all;
        }
      }
    }
    .right-bottom {
      margin-left: 20px;
    }
  }
}
::v-deep .ant-fullcalendar-header .ant-radio-group {
  display: none !important;
}
.calDot {
  width: 7px;
  height: 7px;
  border-radius: 10px;
  background-color: #1890ff;
  display: inline-block;
  position: relative;
  top: -5px;
}
.lrck_tableWrap {
  padding-top: 30px;
  border-top: 2px dashed #d8d8d8;
  margin-top: 30px;
}
table {
  border-color: #f0f0f0;
  // table-layout: fixed;
  /* font-size: 15px; */
}
tr {
  height: 60px;
}
td:nth-child(even) {
}
td:nth-child(odd) {
  width: 100px;
  background: #f0f0f0;
  // font-weight: 800;
  text-align: center;
}
td {
  // color: #262626;
}
.form-item {
  position: relative;
  top: 12px;
  padding: 0 10px 0 10px;
}
.tableText {
  padding-left: 25px;
}
.wcTableWrap {
  table {
    td {
      // height: 40px;
    }
  }
}
.tdThird {
  width: 82px !important;
}

.spin-item {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}
</style>
//
<style lang="scss">
// .ant-fullcalendar-header .ant-radio-group {
//   display: none !important;
// }
//
</style>
